<div class="sub-section-container">
  <div class="row mb-4" [formGroup]="durationsForm">
    @if (getPermission('notificationExpiration')?.visible) {
    <div class="col-3">
      <div class="row" style="margin-right: 30px;">
        <div class="col-6 customLabel" style="padding-right: 0px; font-size: 0.7rem;">{{PreferencesFields.notificationExpiryDesc}}:
          @if (getPermission('notificationExpiration')?.required) {
          <span class="required-asterik">*</span>
          }
        </div>
        <div class="col-6">
          <ejs-dropdownlist #rolesDDL [dataSource]="durationsData" width="160px"
            [formControlName]="PreferencesFields.notificationExpiry" [title]="durationTitle(PreferencesFields.notificationExpiry)"
            [fields]='{ text: "text", value: "value" }'
            [readonly]="getPermission('notificationExpiration')?.readOnly || !isSectionEnabled"
            [enabled]="getPermission('notificationExpiration')?.enable && isSectionEnabled"
            (change)="onExpirationChange($event)"
            [placeholder]='PreferencesFields.notificationExpiryDesc'>
          </ejs-dropdownlist>
          <div class="field-error"
            [ngStyle]="{visibility: (isFormSubmitted && getPermission('notificationExpiration')?.required && durationsForm.controls[PreferencesFields.notificationExpiry].invalid) ? 'visible' : 'hidden'}">
            Field is required</div>
        </div>
      </div>
    </div>
    }
    @if (getPermission('readNotificationExpiration')?.visible) {
    <div class="col-4">
      <div class="row">
        <div class="col-6 customLabel">{{PreferencesFields.notificationReadExpiryDesc}}:
          @if (getPermission('readNotificationExpiration')?.required) {
          <span class="required-asterik">*</span>
          }
        </div>
        <div class="col-4">
          <ejs-dropdownlist #rolesDDL [dataSource]="durationsData" width="160px"
            [formControlName]="PreferencesFields.notificationReadExpiry" [title]="durationTitle(PreferencesFields.notificationReadExpiry)"
            [fields]='{ text: "text", value: "value" }'
            [readonly]="getPermission('readNotificationExpiration')?.readOnly || !isSectionEnabled"
            [enabled]="getPermission('readNotificationExpiration')?.enable && isSectionEnabled"
            (change)="onExpirationChange($event)"
            [placeholder]='PreferencesFields.notificationReadExpiryDesc'>
          </ejs-dropdownlist>
          <div class="field-error"
            [ngStyle]="{visibility: (isFormSubmitted && getPermission('readNotificationExpiration')?.required && durationsForm.controls[PreferencesFields.notificationReadExpiry].invalid) ? 'visible' : 'hidden'}">
            Field is required</div>
        </div>
      </div>
    </div>
    }
  </div>


  <div class="row" *ngIf="showGrid">
    <div class="col-12">
      @if (treeConfig) {
      <div class="preferences-tree">
        <inavista-grid #preferencesTree [config]="treeConfig" />
      </div>
      }
    </div>
    <div class="col mt-3" role="alert">
      <em style="font-size: 10px; font-style: italic;"><span style="font-size: 10px; font-style: italic; font-weight: bolder;">**Important Note:</span> By Selecting SMS Preference, you consent to receiving SMS messages from this Application.</em>
    </div>
  </div>
</div>

<!-- Email / Notification / SMS: a parent ticks or unticks its children; a parent is ticked when all its children that can
     change are (preferencesChange). Greyed when the role's column, the section or the row doesn't allow it. -->
<ng-template #emailCell let-row>
  <ejs-checkbox [checked]="!!row?.[PreferencesFields.isEmailChecked]"
    [disabled]="checkboxLocked(row, PreferencesFields.isEmailChecked)" [title]="checkboxTitle(row, PreferencesFields.isEmailChecked)"
    (change)="preferencesChange(row, PreferencesFields.isEmailChecked, $event.checked)"></ejs-checkbox>
</ng-template>
<ng-template #notificationCell let-row>
  <ejs-checkbox [checked]="!!row?.[PreferencesFields.isNotificationChecked]"
    [disabled]="checkboxLocked(row, PreferencesFields.isNotificationChecked)" [title]="checkboxTitle(row, PreferencesFields.isNotificationChecked)"
    (change)="preferencesChange(row, PreferencesFields.isNotificationChecked, $event.checked)"></ejs-checkbox>
</ng-template>
<ng-template #smsCell let-row>
  <ejs-checkbox [checked]="!!row?.[PreferencesFields.isSMSChecked]"
    [disabled]="checkboxLocked(row, PreferencesFields.isSMSChecked)" [title]="checkboxTitle(row, PreferencesFields.isSMSChecked)"
    (change)="preferencesChange(row, PreferencesFields.isSMSChecked, $event.checked)"></ejs-checkbox>
</ng-template>
